import { Controller } from '@hotwired/stimulus';

// Fills a single shared modal with a body fetched on click, instead of
// rendering one modal per record in the page
export default class extends Controller {
  static targets = ['content'];
  static values = { error: String };

  open = async ({ params: { url } }) => {
    this.contentTarget.innerHTML = "<div class='modal-body vesta-text-center'><i class='fas fa-spinner fa-pulse fa-2x'></i></div>";

    const response = await fetch(url, { headers: { Accept: 'text/html' } });

    if (response.ok && !response.redirected) {
      this.contentTarget.innerHTML = await response.text();
    } else {
      this.contentTarget.innerHTML = '';
      alertMessage(this.errorValue, 'error');
    }
  }
}
